import { CommonModule } from '@angular/common';
import { NgOptimizedImage } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';

import { TtcButtonSharedModule } from '@libs/src/ttc-button-shared/ttc-button-shared.module';
import { TypedDialogModule } from '@libs/src/typed-dialog/typed-dialog.module';

import { PostHogService } from '@libs/src/posthog/post-hog.service';

@Component({
  imports: [
    CommonModule,
    FlexLayoutModule,
    MatIconModule,
    NgOptimizedImage,
    RouterModule,
    TtcButtonSharedModule,
    TypedDialogModule,
  ],
  selector: 'app-ai-announcement-modal',
  standalone: true,
  templateUrl: './ai-announcement-modal.component.html',
})
export class AIAnnouncementModalComponent implements OnInit {
  readonly backgroundColors = ['#2A66FF', '#B2A1FF', '#FAD24B'];
  readonly backgroundImages = [
    '//storage.googleapis.com/ttc-static-images/bg-pattern.2DA14DA.svg',
    '//storage.googleapis.com/ttc-static-images/bg-pattern.E568E9C.svg',
    '//storage.googleapis.com/ttc-static-images/bg-pattern.8F0CA56.svg',
  ];
  readonly gifUrls = [
    '//storage.googleapis.com/ttc-static-images/summarize-feedback.2515B62.gif',
    '//storage.googleapis.com/ttc-static-images/generate-content.47D2998.gif',
    '//storage.googleapis.com/ttc-static-images/why-matched.99297E9.gif',
  ];
  readonly features: Array<{
    description: string;
    iconName: string;
    title: string;
  }> = [
    {
      description: $localize`:@@aiAnnouncementModal.v2.feature3Description:Immediately analyze feedback and identify trends faster with AI-generated summaries.`,
      iconName: 'summarize',
      title: $localize`:@@aiAnnouncementModal.v2.feature3Title:Summarize program feedback`,
    },
    {
      description: $localize`:@@aiAnnouncementModal.v2.feature2Description:Instantly create tailored session content and materials, saving you hours in planning.`,
      iconName: 'auto_awesome',
      title: $localize`:@@aiAnnouncementModal.feature2Title:Generate session content`,
    },
    {
      description: $localize`:@@aiAnnouncementModal.v2.feature1Description:Get AI-generated reasons for every match, driving purposeful connections from the start.`,
      iconName: 'people_connect',
      title: $localize`:@@aiAnnouncementModal.feature1Title:Learn why you're matched`,
    },
  ];
  selectedIndex = 0;

  constructor(
    @Inject(MAT_DIALOG_DATA) readonly data: { hasAccess: boolean },
    readonly dialogRef: MatDialogRef<
      AIAnnouncementModalComponent,
      { shouldRedirect: boolean }
    >,
    private readonly postHogService: PostHogService,
  ) {}

  ngOnInit(): void {
    this.postHogService.capture('AI announcement modal shown', {
      hasAccess: this.data.hasAccess,
    });
  }

  closeDialog(shouldRedirect: boolean) {
    this.dialogRef.close({ shouldRedirect });
  }

  trackFeature(result: 'consent' | 'dismiss' | 'redirect') {
    this.postHogService.capture('AI announcement modal result', {
      action: result,
    });
  }
}
